/**
 *
 * CustomSelect
 *
 */

import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// antd component
import { Form, Select, Empty } from 'antd';

// utils
import { sortByKey } from 'utils/helpers/helper.general';

function CustomSelect({
  mode,
  name,
  label,
  sortBy,
  placeholder,
  options,
  disabled,
  required,
  showSearch,
  // actons
  onSelect,
  tagRender,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-select-wrapper', className);
  const { t } = useTranslation();
  //const { isMobile } = useDeviceDetect();

  const [listOptions, setListOptions] = useState([]);

  useEffect(() => {
    if (options) {
      // sort options
      sortBy && options.sort(sortByKey(sortBy));
      setListOptions(options);
    }
  }, [options]);

  const multipleOptions = mode && {
    mode: mode,
    maxTagCount: 3, // 'responsive'
  };

  mode && tagRender && (multipleOptions.tagRender = tagRender);

  const selectLocale = {
    emptyText: (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t("errors.noData")}
      />
    ),
  };

  return (
    <Form.Item
      key={`${name}-select`}
      label={label}
      name={name}
      className={childClassNames}
      rules={[
        {
          required: !!!disabled && required,
          message: t("inputs.selectRequiredField"),
        },
      ]}
    >
      <Select
        locale={selectLocale}
        placeholder={placeholder || t("inputs.select")}
        optionFilterProp="children"
        onSelect={onSelect}
        showArrow
        showSearch={showSearch}
        optionLabelProp="label"
        getPopupContainer={trigger => trigger.parentElement}
        notFoundContent={
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={t("errors.noData")}
          />
        }
        filterOption={(input, option) =>
          (option?.title &&
            option?.title.toLowerCase().indexOf(input.toLowerCase()) >= 0) ||
          (option?.label &&
            option?.label.toLowerCase().indexOf(input.toLowerCase()) >= 0)
        }
        disabled={disabled}
        {...multipleOptions}
      >
        {listOptions.map((option, i) => (
          <Select.Option
            {...option}
            key={option?.key || option?.value}
            value={option?.value || option?.key}
            label={option?.label || option?.title || option?.value}
          >
            <span
              className="option"
              dangerouslySetInnerHTML={{
                __html: option?.title || option?.label || option?.value,
              }}
            />
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
}

CustomSelect.defaultProps = {
  showSearch: false,
  required: true,
  disabled: false,
};
CustomSelect.propTypes = {
  name: PropTypes.string.isRequired,
  mode: PropTypes.string,
  label: PropTypes.string,
  sortBy: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.array.isRequired,
    PropTypes.string.isRequired,
  ]),
  onSelect: PropTypes.func,
  tagRender: PropTypes.func,
};

export default memo(CustomSelect);
